module.exports = __webpack_public_path__ + "img/small_truck_grey.54be7508.svg";